import actionCreatorFactory from "typescript-fsa";
import api from "../api";
import { Entity } from "../documentUpload/types";
import { State } from "../state";

import { asyncFactory, thunkToAction } from "typescript-fsa-redux-thunk";

const create = actionCreatorFactory("Entities");
const createAsync = asyncFactory<State>(create);

export const createEntity = createAsync<Entity, Entity>(
  "CREATE_ENTITY",
  async (params, dispatch, getState) => {
    return await api.entities.create(params);
  }
);

const createEntityAction = thunkToAction(createEntity.action);
export type CreateEntityActionType = typeof createEntityAction;



// WEBPACK FOOTER //
// ./src/createEntityModal/actions.ts